import moment from "moment";
import * as Yup from "yup";
export const PractitonerHeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        isDecrypted: true,
        nested: { key: "name", value: { index: 0, key: "text" } },
    },
    {
        id: 'phone',
        label: 'Phone Number',
        type: 'text',
        isDecrypted: true,
        nested: { key: "telecom", value: { index: 0, key: "value" } },
        style: { whiteSpace: "nowrap" }
    },
    {
        id: 'address',
        label: 'Address',
        type: 'text',
        isDecrypted: true,
        nested: { key: "address", value: { index: 0, key: "line" } },
    },
];
export const PractitonerDataFields = [
    'name',
    'phone',
    'Address',
];

export const PatientHeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        isDecrypted: true,
        nested: { key: "name", value: { index: 0, key: "text" } },
    },
    {
        id: 'condition',
        label: 'Condition',
        type: 'text',
        isDecrypted: true,
        style: { textAlign: "center" },
        nested: { key: "diseaseName", },
    },
    {
        id: 'symptoms',
        label: 'Symptoms',
        type: 'text',
        isDecrypted: true,
        style: { textAlign: "center" },
        nested: { key: "diseaseDesc", },
    },
];
export const PatientDataFields = [
    'name',
    'condition',
    'symptoms',
];

export const genderOptions = [
    { value: "male", name: "Male" },
    { value: "female", name: "Female" },
    { value: "other", name: "Other" },
];

export const patientListTitle = ["Name", "Gender", "DOB", "Patient Identifier", "Address", "City", "State/Province"]

export const FormikObjInboundCall = {
    initialValues: {
        questionResponse: [],
        orgId: "",
        orgName: "",
        questionnaire: "",
        patientId : "",
        patientName: "",
        howToProcced: "",
        encounterId: "",
        questionnaireId:"",
        serviceLineId: "",
        serviceLineName: ""
    },
    validationSchema: Yup.object({

    }),
}

export const patientSelectionFormikObject = {
    validationSchema: Yup.object({
    firstName:  Yup.string().max(30, "Must be 30 characters or less").matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    lastName: Yup.string().max(30, "Must be 30 characters or less").matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    birthDate: Yup.string()
        .nullable()
        .test(
            "valid-format",
            "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
            function (value) {
            if (!value) return true; 
            const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
            const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
            if (!isValid1 && !isValid2) return false;

            // Check if date is in the future
            const date = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY");
            if (date.isAfter(moment())) {
                return this.createError({
                    message: "Date of birth cannot be in the future.",
                });
            }
            return true;
                  }
                ),
    healthCardNumber: Yup.string().matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
  }),
  validate: values => {
    const errors = {};
    if (values.firstName || values.lastName || values.birthDate || values.healthCardNumber) {
        if(errors.hasOwnProperty("allSearchFieldsEmpty")) 
            delete errors.hasOwnProperty;
    }
    return errors;
  }
}

export const createPatientObjFormik = {
    initialValues: {
        orgId: "",
        orgName: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        gender : "",
        country: "",
        city:"",
        region: "",
        address: "",
        postalCode: "",
        email: "",
        phone_number: "",
        general_practitioner: "",
        hcn: "",
        ext: "",
        create_account : ""
    },
}